export { default as EventLayout1 } from './EventLayout1';
